import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { format } from 'date-fns';
import {
  ExpandCellContainer, ReversedIcon, ProgressBarContainer, ProgressBarBackground, ProgressBar, ProgressBarSpacerContainer,
} from './css';
import ChevronSmallDownOrange from '../../../assets/icons/ChevronSmallDownOrange.svg';
import { routes } from '../../../utils/constants';
import ActionsMenu from '../../../lib/ui/actionsMenu';

export const LocationCellComponent = (props) => {
  if (props.address) {
    return (
      <div>
        {/* {props.address.address1 ? <p>{`${props.address.address1}${props.address.address2 ? ` ${props.address.address2}` : ''},`}</p> : ''} */}
        {props.address.city && props.address.provinceCode ? <p>{`${props.address.city}, ${props.address.provinceCode}`}</p> : ''}
        {props.address.city && !props.address.provinceCode ? <p>{`${props.address.city}`}</p> : ''}
        {!props.address.city && props.address.provinceCode ? <p>{`${props.address.provinceCode}`}</p> : ''}
      </div>
    );
  }

  return null;
};

LocationCellComponent.propTypes = {
  address: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    provinceCode: PropTypes.string,
    postalCode: PropTypes.string,
  }),
};

export const TimeCellComponent = (props) => format(props.time, t('DATE_COLUMN_PATTERN'));

export const ExpandCellComponent = (props) => {
  const dataLengthFlag = props && props.dataLengthFlag;

  return (
    <ExpandCellContainer style={{
      display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'center',
    }}
    >
      <p>{t('Updates')}</p>
      {props.reverse || dataLengthFlag
        ? <ReversedIcon src={ChevronSmallDownOrange} alt="Collapse" />
        : <img src={ChevronSmallDownOrange} alt="Expand" />}
    </ExpandCellContainer>
  );
};

ExpandCellComponent.propTypes = {
  reverse: PropTypes.bool,
  dataLengthFlag: PropTypes.bool,
};

export const OrderStatusCellComponent = (props) => (
  <ProgressBarSpacerContainer>
    <ProgressBarContainer>
      <ProgressBarBackground />
      <ProgressBar progress={props.percentage} color={props.color} />
    </ProgressBarContainer>
    <ProgressBarSpacerContainer>
      <p>{props.status}</p>
    </ProgressBarSpacerContainer>
  </ProgressBarSpacerContainer>
);

OrderStatusCellComponent.propTypes = {
  percentage: PropTypes.number,
  color: PropTypes.string,
  status: PropTypes.string,
};

export const StyledDropdown = (props) => {
  const { isAuthenticated, isAccountAllowed } = props;

  const handleTrackingDetailsClick = () => {
    switch (props.division) {
      case 'Sameday':
        window.open(`${routes.viewShipmentTracking}?division=Sameday&probillNumber=${props.probillNumber}`);
        break;
      case 'Freight':
        window.open(`${routes.viewShipmentTracking}?division=Freight&probillNumber=${props.probillNumber}`);
        break;
      default:
        window.open(`${routes.viewShipmentTracking}?orderId=${props.probillNumber}`);
    }
  };

  const handleShipmentDetailsClick = () => {
    if (props.useOldServices) {
      window.open(`${routes.viewShipment}?division=${props.division}&probillNumber=${props.probillNumber}`);
    } else {
      window.open(`${routes.viewOrder}?probillNumber=${props.probillNumber}${props.division ? `&division=${props.division}` : ''}`);
    }
  };

  const actions = [
    {
      id: 'tracking-detail',
      label: t('ViewTrackingDetails'),
      icon: 'TrackIcon',
      disabled: false,
      action: handleTrackingDetailsClick,
      visible: true,
    },
    {
      id: 'shipment-detail',
      label: t('ViewShipmentDetails'),
      icon: 'ShipmentIcon',
      disabled: !isAuthenticated || !isAccountAllowed,
      action: handleShipmentDetailsClick,
      visible: true,
    },
  ];

  return (<ActionsMenu options={actions} />);
};

StyledDropdown.propTypes = {
  isAuthenticated: PropTypes.bool,
  useOldServices: PropTypes.bool,
  division: PropTypes.string,
  probillNumber: PropTypes.string,
  isAccountAllowed: PropTypes.bool,
};
